/* TST Upsell Variant Popup (global)
   - Opens from Cart Upsell cards (data-upsell-open)
   - Shows compact popup: title + price + tax/shipping + image + option pickers
   - Option pickers are per option (no combined variant titles)
   - Add to cart happens only via "Zum Warenkorb" button
*/
(function () {
  if (window.__tstUpsellDrawerBound) return;
  window.__tstUpsellDrawerBound = true;

  const cache = window.__tstUpsellProductCache || (window.__tstUpsellProductCache = {});
  const state = window.__tstUpsellDrawerState || (window.__tstUpsellDrawerState = {
    open: false,
    handle: null,
    selected: [] // per option index
  });

  function qs(sel, root){ return (root || document).querySelector(sel); }
  function qsa(sel, root){ return Array.from((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    const upsellRoot = qs('[data-tst-cart-upsell]');
    const fmt = upsellRoot && upsellRoot.dataset.moneyFormat;
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && fmt) {
      try { return Shopify.formatMoney(cents, fmt); } catch(e){}
    }
    const val = (Number(cents)/100).toFixed(2) + ' €';
    return '<span class="etrans-money">' + val + '</span>';
  }

  async function getProductJson(handle){
    if (!handle) return null;
    if (cache[handle]) return cache[handle];
    const res = await fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) return null;
    const data = await res.json();
    cache[handle] = data;
    return data;
  }

  async function addToCart(variantId){
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });
    if (!res.ok) throw new Error('add failed');
    return res.json();
  }

  async function refreshCartPopup(){
    try {
      const res = await fetch('/cart?view=popup', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newPopup = doc.querySelector('.popup-cart');
      const currentPopup = document.querySelector('.popup-cart');
      if (newPopup && currentPopup) currentPopup.innerHTML = newPopup.innerHTML;
    } catch(e){}
  }

  function closeDrawer(){
    const drawer = qs('[data-tst-upsell-drawer]');
    if (!drawer) return;
    drawer.hidden = true;
    document.documentElement.classList.remove('tst-upsell-drawer-open');
    document.body.classList.remove('tst-upsell-drawer-open');
    state.open = false;
    state.handle = null;
    state.selected = [];
  }

  function getUniqueOptionValues(product, optionIndex){
    const set = new Set();
    (product.variants || []).forEach(v => {
      const opts = v.options || [];
      if (opts[optionIndex] != null) set.add(opts[optionIndex]);
    });
    return Array.from(set);
  }

  function getExactVariant(product, selected){
    const vars = product.variants || [];
    return vars.find(v => {
      const opts = v.options || [];
      if (!product.options || opts.length < product.options.length) return false;
      for (let i=0; i<product.options.length; i++){
        if (selected[i] == null) return false;
        if (opts[i] !== selected[i]) return false;
      }
      return true;
    }) || null;
  }

  function findBestVariant(product, selected){
    // Try exact match first
    const vars = product.variants || [];
    const exact = vars.find(v => {
      const opts = v.options || [];
      for (let i=0; i<product.options.length; i++){
        if (selected[i] && opts[i] !== selected[i]) return false;
      }
      // If selected includes all options, require exact
      for (let i=0; i<product.options.length; i++){
        if (!selected[i]) return false;
      }
      return true;
    });
    if (exact) return exact;

    // If not all selected, pick first available matching the selected subset
    const subset = vars.find(v => {
      const opts = v.options || [];
      for (let i=0; i<product.options.length; i++){
        if (selected[i] && opts[i] !== selected[i]) return false;
      }
      return v.available;
    });
    return subset || vars.find(v => {
      const opts = v.options || [];
      for (let i=0; i<product.options.length; i++){
        if (selected[i] && opts[i] !== selected[i]) return false;
      }
      return true;
    }) || vars[0] || null;
  }

  function isValueAvailable(product, optionIndex, value, selected){
    const vars = product.variants || [];
    return vars.some(v => {
      if (!v.available) return false;
      const opts = v.options || [];
      if (opts[optionIndex] !== value) return false;
      for (let i=0; i<product.options.length; i++){
        if (i === optionIndex) continue;
        if (selected[i] && opts[i] !== selected[i]) return false;
      }
      return true;
    });
  }

  function priceForValue(product, optionIndex, value, selected){
    // Find the cheapest available variant that matches selected + this value
    const vars = (product.variants || []).filter(v => {
      const opts = v.options || [];
      if (opts[optionIndex] !== value) return false;
      for (let i=0; i<product.options.length; i++){
        if (i === optionIndex) continue;
        if (selected[i] && opts[i] !== selected[i]) return false;
      }
      return v.available;
    });
    if (!vars.length) return null;
    let min = vars[0];
    vars.forEach(v => { if (typeof v.price === 'number' && v.price < min.price) min = v; });
    return min;
  }

  function renderOptions(drawer, product){
    const optionsWrap = qs('[data-upsell-drawer-options]', drawer);
    if (!optionsWrap) return;

    optionsWrap.innerHTML = '';

    (product.options || []).forEach((optName, idx) => {
      const group = document.createElement('div');
      group.className = 'tst-upsell-drawer__option-group';
      group.setAttribute('data-option-index', String(idx));

      const label = document.createElement('div');
      label.className = 'tst-upsell-drawer__option-label';
      label.textContent = (typeof optName === 'string') ? optName : (optName && optName.name) ? optName.name : String(optName);

      const valuesWrap = document.createElement('div');
      valuesWrap.className = 'tst-upsell-drawer__option-values';

      const values = getUniqueOptionValues(product, idx);
      values.forEach(val => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tst-upsell-drawer__opt-btn';
        btn.setAttribute('data-option-index', String(idx));
        btn.setAttribute('data-option-value', val);

        const available = isValueAvailable(product, idx, val, state.selected);
        if (!available) btn.disabled = true;

        const pressed = state.selected[idx] === val;
        btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');

        // label only (price updates at top)
        btn.textContent = val;

        valuesWrap.appendChild(btn);
      });

      group.appendChild(label);
      group.appendChild(valuesWrap);
      optionsWrap.appendChild(group);
    });
  }

  function updateHeader(drawer, product){
    const titleEl = qs('[data-upsell-drawer-title]', drawer);
    const priceEl = qs('[data-upsell-drawer-price]', drawer);
    const imgEl = qs('[data-upsell-drawer-image]', drawer);

    if (titleEl) titleEl.textContent = product.title || '';

    const best = findBestVariant(product, state.selected);
    if (best && typeof best.price === 'number' && priceEl) {
      priceEl.innerHTML = formatMoney(best.price);
    }

    if (imgEl) {
      // Prefer exact variant image when possible
      const exact = getExactVariant(product, state.selected);
      let src = '';
      const imgObj = exact && exact.featured_image ? exact.featured_image : (best && best.featured_image ? best.featured_image : null);
      if (imgObj) {
        if (typeof imgObj === 'string') src = imgObj;
        else if (imgObj.src) src = imgObj.src;
      }
      if (!src) src = product.featured_image || (product.images && product.images[0]) || '';
      if (src) imgEl.src = src;
      imgEl.alt = (product.title || '');
    }
  }

  async function openDrawer(handle, preferredVariantId){
    const drawer = qs('[data-tst-upsell-drawer]');
    if (!drawer) return;

    const statusEl = qs('[data-upsell-drawer-status]', drawer);
    if (statusEl) statusEl.textContent = '';

    const product = await getProductJson(handle);
    if (!product || !product.variants) return;

    state.open = true;
    state.handle = handle;

    // init selection from preferred variant (or first available)
    let base = null;
    const prefNum = preferredVariantId ? Number(preferredVariantId) : null;
    if (prefNum) base = product.variants.find(v => Number(v.id) === prefNum) || null;
    if (!base) base = product.variants.find(v => v.available) || product.variants[0] || null;

    state.selected = (base && base.options) ? base.options.slice(0) : [];

    updateHeader(drawer, product);
    renderOptions(drawer, product);

    drawer.hidden = false;
    document.documentElement.classList.add('tst-upsell-drawer-open');
    document.body.classList.add('tst-upsell-drawer-open');
  }

  async function goToCartAddSelected(){
    const drawer = qs('[data-tst-upsell-drawer]');
    if (!drawer) return;
    const statusEl = qs('[data-upsell-drawer-status]', drawer);

    const product = await getProductJson(state.handle);
    if (!product) return;

    // ensure we have a concrete variant
    const v = findBestVariant(product, state.selected);
    if (!v || !v.available) {
      if (statusEl) statusEl.textContent = 'Nicht verfügbar';
      return;
    }

    try {
      if (statusEl) statusEl.textContent = '✓';
      await addToCart(v.id);
      await refreshCartPopup();

      // tiny confirmation, then close
      window.setTimeout(() => {
        closeDrawer();
        if (statusEl) statusEl.textContent = '';
      }, 500);
    } catch(e){
      if (statusEl) statusEl.textContent = '×';
    }
  }

  document.addEventListener('click', async function(e){
    const back = e.target.closest('[data-upsell-drawer-back]');
    if (back) { closeDrawer(); return; }

    const openBtn = e.target.closest('[data-upsell-open]');
    if (openBtn) {
      const handle = openBtn.getAttribute('data-product-handle');
      const selected = openBtn.getAttribute('data-selected-variant-id');
      openDrawer(handle, selected);
      return;
    }

    const optBtn = e.target.closest('.tst-upsell-drawer__opt-btn');
    if (optBtn) {
      const idx = Number(optBtn.getAttribute('data-option-index'));
      const val = optBtn.getAttribute('data-option-value');

      const product = await getProductJson(state.handle);
      if (!product) return;

      state.selected[idx] = val;

      // update pressed states in this group
      const group = optBtn.closest('.tst-upsell-drawer__option-group');
      if (group) qsa('.tst-upsell-drawer__opt-btn', group).forEach(b => b.setAttribute('aria-pressed','false'));
      optBtn.setAttribute('aria-pressed','true');

      // rerender to update disabled states & prices
      updateHeader(qs('[data-tst-upsell-drawer]'), product);
      renderOptions(qs('[data-tst-upsell-drawer]'), product);
      return;
    }

    const goCart = e.target.closest('[data-upsell-go-cart]');
    if (goCart) {
      goToCartAddSelected();
      return;
    }
  });

})();